/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */

import PaletteIconChevronLeft from '@telus-uds/palette-koodo/build/rn/icons/ChevronLeft'
import PaletteIconChevronRight from '@telus-uds/palette-koodo/build/rn/icons/ChevronRight'
const theme = {
  appearances: {
    alternative: { type: 'variant', values: [ true ] },
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    inverse: { type: 'variant', values: [ true ] },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    },
    quiet: {
      description: 'When it is true, it does not show the decoration',
      type: 'state',
      values: [ true, false ]
    },
    size: {
      description: 'Sets the size of the text and icon; these variants are shared with ChevronLink',
      type: 'variant',
      values: [ 'large', 'small', 'micro' ]
    },
    style: {
      type: 'variant',
      values: [ 'inline', 'subtle', 'feature', 'danger', 'inverse' ]
    }
  },
  rules: [
    {
      if: { hover: true },
      tokens: { color: '#404040', iconDisplace: 4 }
    },
    { if: { pressed: true }, tokens: { color: '#666666' } },
    {
      if: { focus: true },
      tokens: { color: '#000000', outerBorderColor: '#000000' }
    },
    {
      if: { focus: true, pressed: true },
      tokens: { color: '#666666', outerBorderColor: '#666666' }
    },
    { if: { alternative: true }, tokens: { color: '#7a3dfc' } },
    {
      if: { alternative: true, hover: true },
      tokens: { color: '#5b2bc2' }
    },
    {
      if: { alternative: true, pressed: true },
      tokens: { color: '#666666' }
    },
    {
      if: { alternative: true, focus: true },
      tokens: { color: '#7a3dfc', outerBorderColor: '#7a3dfc' }
    },
    {
      if: { alternative: true, focus: true, pressed: true },
      tokens: { color: '#666666', outerBorderColor: '#666666' }
    },
    { if: { inverse: true }, tokens: { color: '#ffffff' } },
    {
      if: { hover: true, inverse: true },
      tokens: { color: '#efefef' }
    },
    {
      if: { inverse: true, pressed: true },
      tokens: { color: '#c9c8c8' }
    },
    {
      if: { focus: true, inverse: true },
      tokens: { color: '#ffffff', outerBorderColor: '#ffffff' }
    },
    {
      if: { focus: true, inverse: true, pressed: true },
      tokens: { color: '#c9c8c8', outerBorderColor: '#c9c8c8' }
    },
    {
      if: { size: 'large' },
      tokens: { blockLineHeight: 1.4, fontSize: 20, iconSize: 20 }
    },
    {
      if: { size: 'small' },
      tokens: { blockLineHeight: 1.42857142857, fontSize: 14, iconSize: 16 }
    },
    {
      if: { size: 'micro' },
      tokens: { blockLineHeight: 1.33333333333, fontSize: 12, iconSize: 16 }
    },
    {
      if: { focus: true, quiet: true },
      tokens: { color: '#000000', textLine: 'none' }
    },
    {
      if: { pressed: true, quiet: true },
      tokens: { color: '#595959', textLine: 'underline' }
    },
    {
      if: { focus: true, pressed: true, quiet: true },
      tokens: { color: '#595959', textLine: 'underline' }
    },
    { if: { style: 'inline' }, tokens: { color: '#000000' } },
    {
      if: { focus: true, style: 'inline' },
      tokens: { color: '#000000', outerBorderColor: '#000000' }
    },
    {
      if: { hover: true, style: 'inline' },
      tokens: { color: '#404040', textLine: 'none' }
    },
    {
      if: { pressed: true, style: 'inline' },
      tokens: { color: '#595959', textLine: 'none' }
    },
    {
      if: { focus: true, pressed: true, style: 'inline' },
      tokens: { outerBorderColor: '#595959' }
    },
    { if: { style: 'subtle' }, tokens: { color: '#595959' } },
    {
      if: { focus: true, style: 'subtle' },
      tokens: { color: '#000000', outerBorderColor: '#000000' }
    },
    {
      if: { hover: true, style: 'subtle' },
      tokens: { color: '#404040', textLine: 'none' }
    },
    {
      if: { pressed: true, style: 'subtle' },
      tokens: { color: '#595959', textLine: 'none' }
    },
    {
      if: { focus: true, pressed: true, style: 'subtle' },
      tokens: { outerBorderColor: '#595959' }
    },
    { if: { style: 'feature' }, tokens: { color: '#7a3dfc' } },
    {
      if: { focus: true, style: 'feature' },
      tokens: { color: '#7a3dfc', outerBorderColor: '#7a3dfc' }
    },
    {
      if: { hover: true, style: 'feature' },
      tokens: { color: '#5b2bc2', textLine: 'none' }
    },
    {
      if: { pressed: true, style: 'feature' },
      tokens: { color: '#595959', textLine: 'none' }
    },
    {
      if: { focus: true, pressed: true, style: 'feature' },
      tokens: { outerBorderColor: '#595959' }
    },
    { if: { style: 'danger' }, tokens: { color: '#c9370b' } },
    {
      if: { focus: true, style: 'danger' },
      tokens: { color: '#c9370b', outerBorderColor: '#c9370b' }
    },
    {
      if: { hover: true, style: 'danger' },
      tokens: { color: '#c9370b', textLine: 'none' }
    },
    {
      if: { pressed: true, style: 'danger' },
      tokens: { color: '#595959', textLine: 'none' }
    },
    {
      if: { focus: true, pressed: true, style: 'danger' },
      tokens: { outerBorderColor: '#595959' }
    },
    { if: { style: 'inverse' }, tokens: { color: '#ffffff' } },
    {
      if: { focus: true, style: 'inverse' },
      tokens: { color: '#ffffff', outerBorderColor: '#ffffff' }
    },
    {
      if: { hover: true, style: 'inverse' },
      tokens: { color: '#efefef', textLine: 'none' }
    },
    {
      if: { pressed: true, style: 'inverse' },
      tokens: { color: '#666666', textLine: 'none' }
    },
    {
      if: { focus: true, pressed: true, style: 'inverse' },
      tokens: { outerBorderColor: '#666666' }
    },
    {
      if: { quiet: true, style: 'inline' },
      tokens: { color: '#000000', textLine: 'none' }
    },
    {
      if: { focus: true, quiet: true, style: 'inline' },
      tokens: {
        color: '#000000',
        outerBorderColor: '#000000',
        textLine: 'none'
      }
    },
    {
      if: { hover: true, quiet: true, style: 'inline' },
      tokens: { color: '#404040', textLine: 'underline' }
    },
    {
      if: { pressed: true, quiet: true, style: 'inline' },
      tokens: { color: '#595959' }
    },
    {
      if: { focus: true, pressed: true, quiet: true, style: 'inline' },
      tokens: { outerBorderColor: '#595959' }
    },
    {
      if: { quiet: true, style: 'subtle' },
      tokens: { color: '#595959', textLine: 'none' }
    },
    {
      if: { focus: true, quiet: true, style: 'subtle' },
      tokens: {
        color: '#000000',
        outerBorderColor: '#000000',
        textLine: 'none'
      }
    },
    {
      if: { hover: true, quiet: true, style: 'subtle' },
      tokens: { color: '#404040', textLine: 'underline' }
    },
    {
      if: { pressed: true, quiet: true, style: 'subtle' },
      tokens: { color: '#595959' }
    },
    {
      if: { focus: true, pressed: true, quiet: true, style: 'subtle' },
      tokens: { outerBorderColor: '#595959' }
    },
    {
      if: { quiet: true, style: 'feature' },
      tokens: { color: '#7a3dfc', textLine: 'none' }
    },
    {
      if: { focus: true, quiet: true, style: 'feature' },
      tokens: {
        color: '#7a3dfc',
        outerBorderColor: '#7a3dfc',
        textLine: 'none'
      }
    },
    {
      if: { hover: true, quiet: true, style: 'feature' },
      tokens: { color: '#5b2bc2', textLine: 'underline' }
    },
    {
      if: { pressed: true, quiet: true, style: 'feature' },
      tokens: { color: '#595959' }
    },
    {
      if: { focus: true, pressed: true, quiet: true, style: 'feature' },
      tokens: { outerBorderColor: '#595959' }
    },
    {
      if: { quiet: true, style: 'danger' },
      tokens: { color: '#c9370b', textLine: 'none' }
    },
    {
      if: { focus: true, quiet: true, style: 'danger' },
      tokens: {
        color: '#c9370b',
        outerBorderColor: '#c9370b',
        textLine: 'none'
      }
    },
    {
      if: { hover: true, quiet: true, style: 'danger' },
      tokens: { color: '#c9370b', textLine: 'underline' }
    },
    {
      if: { pressed: true, quiet: true, style: 'danger' },
      tokens: { color: '#595959' }
    },
    {
      if: { focus: true, pressed: true, quiet: true, style: 'danger' },
      tokens: { outerBorderColor: '#595959' }
    },
    {
      if: { quiet: true, style: 'inverse' },
      tokens: { color: '#ffffff', textLine: 'none' }
    },
    {
      if: { focus: true, quiet: true, style: 'inverse' },
      tokens: {
        color: '#ffffff',
        outerBorderColor: '#ffffff',
        textLine: 'none'
      }
    },
    {
      if: { hover: true, quiet: true, style: 'inverse' },
      tokens: { color: '#efefef', textLine: 'underline' }
    },
    {
      if: { pressed: true, quiet: true, style: 'inverse' },
      tokens: { color: '#666666' }
    },
    {
      if: { focus: true, pressed: true, quiet: true, style: 'inverse' },
      tokens: { outerBorderColor: '#666666' }
    }
  ],
  tokens: {
    blockLineHeight: 1.5,
    color: '#000000',
    fontSize: 16,
    iconDisplace: 0,
    iconSize: 16,
    iconSpace: 1,
    leftIcon: PaletteIconChevronLeft,
    outerBorderColor: 'rgba(0, 0, 0, 0)',
    rightIcon: PaletteIconChevronRight,
    textLine: 'none'
  }
}
export default theme
